export function getGenerationName(generation, parent_name = "", fullName = "", lastName = false, isStartOfLine = false, topOfLineFirstName = "", topOfLineSpouseFirstName = "", topOfLineLastName = "", specialName = "",parent_special_name = "") {
    // console.log("Parent Name", parent_name);
    // console.log("fullName",fullName)
    console.log("specialName", specialName)
    console.log("parent_special_name", parent_special_name)

    //if start of line is true then get its data
    if (isStartOfLine) {
        // return topOfLineFirstName + " & " + topOfLineSpouseFirstName + " " + topOfLineLastName;
        const parts = [];
        if (topOfLineFirstName) parts.push(topOfLineFirstName);
        if (topOfLineSpouseFirstName) parts.push(topOfLineSpouseFirstName);
        const combined = parts.join(" & ");
        return combined + (topOfLineLastName ? " " + topOfLineLastName : "");
    }

    //if top of line 
    if (generation == 1) {
        // return "Root - Head of the family";
        return "Start/Top of the Line";
        // return fullName?.split(" ")[0];
    }
    // else if (specialName){
    //     return fullName?.split(" ")[0] + " " + specialName;
    // }
    // else if(generation == 2){
    //     if(!lastName){
    //                 return fullName?.split(" ")[0];
    //     }
    //     return fullName?.split(" ")[0] + " " + fullName?.split(" ").pop()?.charAt(0);
    // }

    //if head of line 
    else if (generation == 2) {
        // debugger
        if (!lastName) {
            return fullName?.split(" ")[0] + " " + (specialName?.charAt(0).toUpperCase() || "");
        }
        // Get all parts of the full name
        const nameParts = fullName?.split(" ");

        // If there are at least 2 names, return first name + middle initial
        if (nameParts && nameParts.length >= 2) {
            return nameParts[0] + " " + nameParts[1].charAt(0).toUpperCase();
        }

        // Fallback if only one name exists
        return fullName?.split(" ")[0];
    }

    //for rest of the child generations
    else {

        // if(!lastName){
        //             return parent_name?.split(" ")[0];
        // }
        // return parent_name?.split(" ")[0] + " " + parent_name?.split(" ").pop()?.charAt(0);
        if(parent_special_name){
            return parent_name?.split(" ")[0] + " " + parent_special_name?.charAt(0).toUpperCase() ;
        }
        if (!lastName) {
            return parent_name?.split(" ")[0];
        }


        // Get all parts of the full name
        const nameParts = parent_name?.split(" ");

        // If there are at least 2 names, return first name + middle initial
        if (nameParts && nameParts.length >= 2) {
            return nameParts[0] + " " + nameParts[1].charAt(0).toUpperCase();
        }

        // Fallback if only one name exists
        return parent_name?.split(" ")[0];
    }

}

export function getOrdinalSuffix(num) {
    if (isNaN(num)) {
        num = Number(num);
    }

    const j = num % 10,
        k = num % 100;
    if (j === 1 && k !== 11) return 'st';
    if (j === 2 && k !== 12) return 'nd';
    if (j === 3 && k !== 13) return 'rd';
    return 'th';
}


/**
 * Gets the title based on generation level
 * @param {number} generationLevel - The generation level (0, 1, 2, etc.)
 * @returns {string} - The title string
 */
export function getViewFirstSubheading(generationLevel) {
    return "Start/Top of the Line";
}